// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".collaboration-logos[data-v-b400216e]{display:flex;position:relative;justify-content:center;align-items:center}@media(max-width: 767px){.collaboration-logos[data-v-b400216e]{flex-flow:column}}.collaboration-x[data-v-b400216e]{filter:invert(1)}.collaboration-partner-logo[data-v-b400216e],.collaboration-me-logo[data-v-b400216e]{max-width:300px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
